import { createFileRoute } from '@tanstack/react-router';
import { StorageDisksPage } from '@/features/storage-disk/list-page';
import { requirePermission } from '@/features/auth/access';
export const Route = createFileRoute('/_authenticated/system/storage-disks')({
  beforeLoad: ({ context, location }) =>
    requirePermission(context.queryClient, location.href, 'storageDisks:read'),
  component: StorageDisksPage,
});
